<!--  -->
<template>
  <div class="padd60">
      <div class="first">
        <img src="../../assets/images/develop.jpg"/>
        <div class="title">
          <h3>职业发展</h3>
          <p>每份工作都有价值，成就您的事业目标</p>
        </div>
      </div>
      <div class="second">
        <h4>在这里，享受工作与生活，与我们一起创造美好未来 </h4>
        <span class="iconTitle" style="display: inline-block"></span>
      </div>
      <div class="third">
        <img src="../../assets/images/team.jpg"/>
      </div>
      <div class="bg">
        <div class="four">
          <div class="sideLeft">
            <h4>工作机会</h4>
            <p class="iconTitle"></p>
            <div class="jion">
              <h6>国科恒通欢迎您的加入！</h6>
              <p style="padding:.2rem 0;"> 如有意向，请发送邮件至：</p>
              <p style="color:#F9BD00;">hr-thpower@thpower.com</p>
            </div>
          </div>
          <div class="sideRight">
            <div class="item" v-for="(item,index) in positionData">
              <div @click="showToggle(item,index)">
                <div style="display: inline-block;width:90%">
                  <h5>{{item.title}}</h5>
                  <p>{{item.explain}}</p>
                </div>
                <img  v-show="!item.isShow" src="../../assets/images/right.svg"/>
                <img  v-show="item.isShow" src="../../assets/images/bottom.svg"/>
              </div>
              <div class="detail" v-show="item.isShow">
                <div style="padding-top:20px;">
                  <h5>{{item.positionTitle}}</h5>
                  <p v-for="(item,index) in item.positionDetail">{{item}}</p>
                </div>
                <div>
                  <h5>{{item.requireTitle}}</h5>
                  <p v-for="(item,index) in item.requireDetail">{{item}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Product',
  components: {},
  data() {
    return {
       positionData:[
          {
            isShow:false,
            title:"产品经理",
            explain:"智慧能源产品事业部 | 产品类 | 中国-北京-海淀区 | 2021年 01月20日",
            positionTitle:"岗位职责",
            positionDetail:["1、负责公司增量配电网生产和调度管理系统的产品策划、市场调研和需求分析", "2、主持开展并具体编写产品的MRD（市场需求文档）、PRD（产品需求文档）工作", "3、协同开发经理、制订软件开发项目的计划，实施整个研发项目的管理", "4、支撑销售团队，开展售前方案编写和客户交流工作，参与项目需求调研分析并维持良好的客户关系"],
            requireTitle:"任职要求",
            requireDetail:["1、本科以上学历、电力行业相关专业或信息管理、软件工程、计算机相关专业，最少五年以上相关行业工作经验", "2、要求有电网生产管理系统、调度系统等五年以上设计、开发或项目管理经验", "3、较强的沟通协调能力，富有责任心、能够承受较大的工作压力", " 4、有较强的团队合作精神和敬业精神，能接受短期出差"]
          },
          {
              isShow:false,
              title:"项目经理",
              explain:"数字电网业务事业部 | 项目类 | 中国-北京-海淀区 | 2021年 01月20日",
              positionTitle:"岗位职责",
              positionDetail:[],
              requireTitle:"任职要求",
              requireDetail:["1、本科以上学历、电力行业相关专业或信息管理、软件工程、计算机相关专业，最少五年以上相关行业工作经验", "2、要求有电网生产管理系统、调度系统等五年以上设计、开发或项目管理经验", "3、较强的沟通协调能力，富有责任心、能够承受较大的工作压力", " 4、有较强的团队合作精神和敬业精神，能接受短期出差"]
          },
          {
              isShow:false,
              title:"需求工程师",
              explain:"智慧能源产品事业部 | 产品类 | 中国-北京-海淀区 | 2021年 01月20日",
              positionTitle:"岗位职责",
              positionDetail:[],
              requireTitle:"任职要求",
              requireDetail:["1、本科以上学历、电力行业相关专业或信息管理、软件工程、计算机相关专业，最少五年以上相关行业工作经验", "2、要求有电网生产管理系统、调度系统等五年以上设计、开发或项目管理经验", "3、较强的沟通协调能力，富有责任心、能够承受较大的工作压力", " 4、有较强的团队合作精神和敬业精神，能接受短期出差"]
          },
          {
              isShow:false,
              title:"JAVA高级工程师",
              explain:"智慧能源产品事业部 | 研发类 | 中国-北京-海淀区 | 2021年 01月20日",
              positionTitle:"岗位职责",
              positionDetail:[],
              requireTitle:"任职要求",
              requireDetail:["1、本科以上学历、电力行业相关专业或信息管理、软件工程、计算机相关专业，最少五年以上相关行业工作经验", "2、要求有电网生产管理系统、调度系统等五年以上设计、开发或项目管理经验", "3、较强的沟通协调能力，富有责任心、能够承受较大的工作压力", " 4、有较强的团队合作精神和敬业精神，能接受短期出差"]
          },
          // {
         //     isShow:false,
         //     title:"C++软件工程师",
         //     explain:"数字电网业务事业部 | 产品类 | 中国-广州-黄埔区 | 2021年 01月20日",
         //     positionTitle:"岗位职责",
         //     positionDetail:[],
         //     requireTitle:"任职要求",
         //     requireDetail:["1、本科以上学历、电力行业相关专业或信息管理、软件工程、计算机相关专业，最少五年以上相关行业工作经验", "2、要求有电网生产管理系统、调度系统等五年以上设计、开发或项目管理经验", "3、较强的沟通协调能力，富有责任心、能够承受较大的工作压力", " 4、有较强的团队合作精神和敬业精神，能接受短期出差"]
         // },
          {
              isShow:false,
              title:"销售经理",
              explain:"综合能源服务事业部 | 业务类 | 中国-山西、福建 | 2021年 01月20日",
              positionTitle:"岗位职责",
              positionDetail:[],
              requireTitle:"任职要求",
              requireDetail:["1、本科以上学历、电力行业相关专业或信息管理、软件工程、计算机相关专业，最少五年以上相关行业工作经验", "2、要求有电网生产管理系统、调度系统等五年以上设计、开发或项目管理经验", "3、较强的沟通协调能力，富有责任心、能够承受较大的工作压力", " 4、有较强的团队合作精神和敬业精神，能接受短期出差"]
          }
        ]
    }
  },
  created() {},
  mounted() {},

  methods: {
      // 点击展开折叠菜单事件
      showToggle:function(item,ind){
        this.positionData.forEach(i => {
            // 判断如果数据中的menuList[i]的show属性不等于当前数据的isSubShow属性那么menuList[i]等于false
            if (i.isShow !== this.positionData[ind].isShow) {
                i.isShow = false;
            }
        });
        item.isShow = !item.isShow;
      }
  }
}
</script>
<style scoped lang="less">
  @keyframes animation
  {
    from {bottom:0;}
    to {bottom:30%;}
  }
  .bg{
    background-size:26%;
    background-image:url("../../assets/images/picBg.png");
    background-repeat:no-repeat;
    background-position:100% 100%;
  }
  .first {
    text-align: center;
    position: relative;
    img{
      width:100%;
    }
    .title{
      animation: animation 1s ease;
      -webkit-animation: animation 1s ease ;
      -moz-animation: animation 1s ease;
      position: absolute;
      bottom: 30%;
      width: 100%;
      h3{
        font-size:.5rem;
        font-weight: 500;
        color: #fff;
        font-family: ShiShangZhongHeiJianTi;
      }
      p{
        padding-top:.3rem;
        color:#FABE00;
        font-size:.25rem;
        font-family: Microsoft YaHei;
      }
    }
  }
  .iconTitle{
    margin-top:.1rem;
    width: 1rem;
    height: .06rem;
    background: #FABE00;
  }
  .second{
    padding:.6rem;
    font-size:.3rem;
    text-align: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #4C4C4C;
  }
  .third{
    width:60%;
    margin:0 auto;
    padding-bottom:.6rem;
    img{
      width:100%;
    }
  }
  .four{
    width:60%;
    margin:0 auto;
    padding-bottom: 1rem;
    .sideLeft{
      text-align: left;
      display: inline-block;
      width:30%;
      vertical-align: top;
      h4{
        font-size: .3rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #4C4C4C;
      }
    }
    .sideRight{
      width:70%;
      text-align: left;
      display: inline-block;
      font-size: .2rem;
      .item{
        :first-child{
          padding-top:0;
        }
        cursor:pointer;
        padding:.1rem 0;
        border-bottom: 1px solid #D7D7D7;
        img{
          width:.2rem;
          float: right;
          padding-top:.2rem;
        }
        .detail{
          h5{
            font-size: .2rem;
            color: #4C4C4C;
            font-family: Microsoft YaHei;
          }
          div{
            padding:.15rem 0;
            p{
              padding:5px 0;
              line-height:20px;
            }
          }
        }
        h5{
          font-size: .21rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #F9BD00;
          padding:10px 0;
        }

      }
    }
    .jion{
      padding-top:.5rem;
      font-size:.3rem;
      p{
        font-size:.2rem;
      }
    }
  }
  @media only screen and (max-width: 499px) {
    .first {
      .title{
        h3{
          font-size:.6rem;
        }
        p{
          padding-top:.5rem;
          font-size:.25rem;
        }
      }
    }
    .second{
      font-size:.4rem;
    }
    .third{
      width:80%;
    }
    .four{
      width:80%;
      .sideLeft{
        width:100%;
        padding-bottom:1rem;
        h4{
          font-size: .6rem;
        }
      }
      .sideRight{
        width:100%;
        .item {
          padding: 0.5rem 0;
          line-height:.8rem;
          img {
            width: .6rem;
            padding-top: 1.2rem;
          }
        }
      }
      .jion{
        padding-top:.5rem;
        p{
          font-size:.25rem;
        }
      }
    }
  }
  @media only screen and (min-width: 500px) and (max-width: 922px)  {
    .first {
      .title{
        h3{
          font-size:.6rem;
        }
        p{
          padding-top:.5rem;
          font-size:.25rem;
        }
      }
    }
    .second{
      font-size:.4rem;
    }
    .third{
      width:80%;
    }
    .four{
      width:80%;
      .sideLeft{
        width:100%;
        padding-bottom:.5rem;
        h4{
          font-size: .4rem;
        }
      }
      .sideRight{
        width:100%;
        .item {
          padding: 0.3rem 0;
          line-height:.5rem;
          img {
            width: .5rem;
            padding-top: .35rem;
          }
        }
      }
      .jion{
        padding-top:.5rem;
        p{
          font-size:.25rem;
        }
      }
    }
  }
</style>
